import { Mutation, MutationTree } from 'vuex'
import { State } from './state'
import {ProductAggregatedStatUruchomieniaSum} from "@/store/modules/statsUruchomienia/types";
import _ from 'lodash'
import {ObjectDataWithPaginator} from "@/store/modules/dashboard/types";


export function updatingAggregatedStatsUruchomieniaSum(state: State,  forceUpdate: boolean = false) {
    state.aggregatedStatsUruchomieniaSumUpdating = true;
    state.aggregatedStatsUruchomieniaSumBuffer = (forceUpdate) ? [] : state.aggregatedStatsUruchomieniaSum;
}

export function updatedAggregatedStatsUruchomieniaSum(state: State) {
    state.aggregatedStatsUruchomieniaSumUpdating = false;
    state.aggregatedStatsUruchomieniaSum = _.sortBy(state.aggregatedStatsUruchomieniaSumBuffer, o => o.productId);
    state.aggregatedStatsUruchomieniaSumBuffer = [];
}

export function loadedAggregatedStatsUruchomieniaSumForProduct(state: State, productStat: ProductAggregatedStatUruchomieniaSum) {
    state.aggregatedStatsUruchomieniaSumBuffer.push(productStat);
}

export function loadingAggregatedStatsUruchomieniaBetweenDatesForProduct(state: State) {
    state.aggregatedStatsUruchomieniaLoading = true;
}

export function loadedAggregatedStatsUruchomieniaForProduct(state: State, data: ObjectDataWithPaginator) {
    state.aggregatedStatsUruchomieniaLoading = false;
    state.aggregatedStatsUruchomienia = data.data as Array<object>;
    state.aggregatedStatsUruchomieniaCurrentPage = data.currentPage;
    state.aggregatedStatsUruchomieniaTotal = data.total;
}

export function loadingDetailedStatsUruchomieniaBetweenDatesForProduct(state: State) {
    state.detailedStatsUruchomieniaLoading = true;
}

export function loadedDetailedStatsUruchomieniaForProduct(state: State, data: Array<object>) {
    state.detailedStatsUruchomieniaLoading = false;
    state.detailedStatsUruchomienia = data as Array<object>;
}


export default <MutationTree<State>> {
    updatingAggregatedStatsUruchomieniaSum,
    updatedAggregatedStatsUruchomieniaSum,
    loadedAggregatedStatsUruchomieniaSumForProduct,
    loadingAggregatedStatsUruchomieniaBetweenDatesForProduct,
    loadedAggregatedStatsUruchomieniaForProduct,
    loadingDetailedStatsUruchomieniaBetweenDatesForProduct,
    loadedDetailedStatsUruchomieniaForProduct
}
